
import { Component, Vue, Watch, Prop, ProvideReactive } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

import { CaseDetails, TemplateDetails, User, CaseField } from "@/types"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import CaseDetailsHeader from "@/components/CaseDetails/CaseDetailsHeader.vue"
import CaseSideBar from "@/components/CaseDetails/CaseSideBar.vue"
import CaseFields from "@/components/CaseDetails/CaseFields.vue"
import CaseFiles from "@/components/CaseDetails/CaseFiles.vue"
import KeyEntries from "@/components/CaseDetails/KeyEntries.vue"
import MapDisplay from "@/components/Controls/Map.vue"
import CaseActions from "@/components/CaseDetails/CaseActions.vue"

import CaseUsers from "@/components/CaseDetails/CaseUsers.vue"
import Invite from "@/components/CaseDetails/Users/Invite.vue"
import TabPage from "@/components/TabPage.vue"

import Comment from "@/components/CaseDetails/Comment.vue"
import History from "@/components/CaseDetails/History.vue"

import { LayoutLocations } from "@/types/templateLayout"
import CaseFile from "@/types/caseFile"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"case-header": CaseDetailsHeader,
		"case-fields": CaseFields,
		"case-actions": CaseActions,
		"map-display": MapDisplay,
		"case-files": CaseFiles,
		"key-entries": KeyEntries,
		"case-side-bar": CaseSideBar,
		"tab-page": TabPage,
		"case-users": CaseUsers,
		"invite-users": Invite,
		"history": History,
		"comment": Comment
	}
})
export default class Mobile extends Vue {
	@Prop()
	public currentCase!: CaseDetails | null

	@Prop()
	public me!: User

	@Prop({ default: false })
	titleTemplateEnabled!: boolean

	@Prop({ default: false })
	canEditCurrentCase!: boolean

	@Prop({ default: true })
	canCreateComments!: boolean

	@Prop()
	template!: TemplateDetails

	@Prop({ default: false })
	hasMap!: boolean

	@Prop({ default: true })
	showAttachments!: boolean

	@Prop({ default: true })
	showTimeline!: boolean

	@Prop({ default: () => [] })
	caseFiles!: CaseFile[]

	@Prop({ default: null })
	currentCaseTemplate!: TemplateDetails | null

	private layoutLocations = LayoutLocations;

	private get hasUserRoles (): boolean {
		return !!this.currentCase && Object.keys(this.currentCase.fields).some(fieldId => this.currentCase!.fields[fieldId].field.dataType === "user-role")
	}

	templateIdChanged (templateId: string) {
		this.$emit("templateIdChanged", templateId)
	}
}
